<template>
  <div class="cpt-message-container">
    <div class="message-container">
      <div class="message-scroll-wrapper" :class="{ animating: showAnimate }">
        <CptMessageItem
          v-for="(message, index) in messageList"
          :key="index"
          :message="message"
        ></CptMessageItem>
      </div>
    </div>
    <div class="static-message" @click="handleJumpChat">
      <img
        class="speaker-icon"
        v-src="
          'https://imgheybox.max-c.com/oa/2024/11/07/4740aadd4c70625b061a9897d55fcdd8.png'
        "
      />
      <div v-if="type == 'vote'" class="static-tip">
        {{ userCount }}人正在官方语音频道讨论 点击加入
      </div>
      <div v-else class="static-tip">{{ userCount }}人正在讨论</div>
    </div>
  </div>
</template>

<script>
import { getChatMessage } from '_api/activity/tga-2024';
import CptMessageItem from './cpt-message-item';
export default {
  props: {
    channelId: {
      default: '',
      type: String,
    },
    type: {
      default: 'type',
      type: String,
    },
  },
  components: {
    CptMessageItem,
  },
  data() {
    return {
      interval: null,
      currentIndex: 0,
      showAnimate: false,

      userCount: 0,
      messageList: [],
    };
  },

  mounted() {
    this.requestMessage();
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
    async requestMessage() {
      console.log('start query');
      let { data } = await getChatMessage({
        room_id: '3713772842432856064',
        channel_id: '3713774676165541888',
        seq: 0,
        limit: 40,
      });
      let { status, result } = data;
      if (status == 'ok') {
        console.log(result);
        this.userCount = result.room_user_count;
        this.messageList = this.formatMessageList(result.list);
        this.$nextTick(() => {
          this.startCarousel();
        });
      }
    },
    startCarousel() {
      this.interval && clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.showAnimate = true;
        setTimeout(() => {
          this.messageList.push(this.messageList.shift());
          this.showAnimate = false;
        }, 500);
      }, 3000);
    },
    stopCarousel() {
      clearInterval(this.interval);
      this.interval = null;
    },
    handleJumpChat() {
      this.$emit('jump');
    },
    formatMessageList(list) {
      return list.map((message) => {
        return {
          nickname: message.nickname,
          im_seq: message.im_seq,
          avatar: message.avatar,
          content: this.formatContent(message),
        };
      });
    },
    formatContent(message) {
      if (message.msg_type == 7 || message.msg_type == 3) {
        return '[图片]';
      } else {
        return message.msg
          .replace(/\[custom[^\]]*\]/g, '[自定义表情]')
          .replace(/@\{[^}]*\}/g, '');
      }
    },
  },
};
</script>

<style lang="less">
.cpt-message-container {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  .message-container {
    width: 100%;
    height: 64px;
    padding-top: 4px;
    position: relative;
    overflow: hidden;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0px,
      rgba(0, 0, 0, 1) 4px
    );
    .message-scroll-wrapper {
      height: fit-content;

      &.animating {
        transform: translateY(-32px);
        transition: transform 0.5s ease;
      }
    }
  }
  .static-message {
    margin-top: 4px;
    height: 19px;
    padding: 0 12px 0 6px;
    display: flex;
    align-items: center;
    background: #121316;
    border-radius: 24px;
    width: fit-content;
    .speaker-icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
    .static-tip {
      color: #7dd95e;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
    }
  }
}
</style>
